<div class="d-flex mb-3 align-items-center">
  <span>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8332 3.64069V4.58736L3.70387 4.67936C3.31589 4.71058 2.94958 4.871 2.66351 5.13494C2.37745 5.39889 2.18814 5.75114 2.12587 6.13536C2.09831 6.30736 2.07298 6.47958 2.04987 6.65203C2.04468 6.69375 2.05277 6.73605 2.073 6.77291C2.09323 6.80977 2.12456 6.83932 2.16253 6.85736L2.21387 6.88136C5.8332 8.59469 10.1672 8.59469 13.7859 6.88136L13.8372 6.85736C13.8751 6.83922 13.9062 6.80962 13.9263 6.77277C13.9464 6.73592 13.9544 6.69368 13.9492 6.65203C13.9266 6.47945 13.9015 6.30721 13.8739 6.13536C13.8116 5.75114 13.6223 5.39889 13.3362 5.13494C13.0502 4.871 12.6838 4.71058 12.2959 4.67936L11.1665 4.58803V3.64136C11.1666 3.36193 11.0664 3.09175 10.8841 2.87997C10.7018 2.66819 10.4495 2.52887 10.1732 2.48736L9.35987 2.36536C8.45821 2.23059 7.54153 2.23059 6.63987 2.36536L5.82653 2.48736C5.55032 2.52886 5.29816 2.66808 5.11587 2.87972C4.93359 3.09136 4.83329 3.36138 4.8332 3.64069ZM9.2112 3.35403C8.4081 3.23407 7.59164 3.23407 6.78853 3.35403L5.9752 3.47603C5.93574 3.48193 5.89971 3.5018 5.87365 3.53201C5.84759 3.56223 5.83324 3.60079 5.8332 3.64069V4.51736C7.27647 4.43493 8.72327 4.43493 10.1665 4.51736V3.64069C10.1665 3.60079 10.1521 3.56223 10.1261 3.53201C10.1 3.5018 10.064 3.48193 10.0245 3.47603L9.2112 3.35403Z" fill="#969696"/>
<path d="M14.0785 8.04668C14.0771 8.02512 14.0706 8.00421 14.0594 7.98574C14.0482 7.96728 14.0327 7.9518 14.0142 7.94065C13.9957 7.9295 13.9748 7.92301 13.9532 7.92174C13.9317 7.92047 13.9101 7.92445 13.8905 7.93334C10.1765 9.57801 5.82313 9.57801 2.10913 7.93334C2.08945 7.92445 2.06791 7.92047 2.04635 7.92174C2.0248 7.92301 2.00387 7.9295 1.98538 7.94065C1.96688 7.9518 1.95137 7.96728 1.94018 7.98574C1.92899 8.00421 1.92245 8.02512 1.92113 8.04668C1.85361 9.323 1.92222 10.6029 2.1258 11.8647C2.18794 12.249 2.37718 12.6014 2.66326 12.8655C2.94934 13.1296 3.31572 13.2901 3.7038 13.3213L4.9518 13.4213C6.98047 13.5853 9.01847 13.5853 11.0478 13.4213L12.2958 13.3213C12.6839 13.2901 13.0503 13.1296 13.3363 12.8655C13.6224 12.6014 13.8117 12.249 13.8738 11.8647C14.0778 10.6013 14.1471 9.32134 14.0785 8.04734" fill="#969696"/>
</svg>


  </span>
  <span class="f-12 font-weight-500 ml-2 text-black">
   Experience
  </span>
</div>
@for(exp of experience; track exp; let i = $index) {
     <div class="mb-3" style="text-transform: capitalize;">
        <div  class="position-relative">
            <div class="d-flex mb-1">
              <div>
                  <span class="clogo c-pointer" (click)="openUrl(exp?.company?.website, 'website')">
                    @if(!exp.companylogo) {
                    <i class="fas fa-building" ></i>
                    } @else {
                      <img [src]="exp.companylogo" class="img-fluid" alt="company name">
                    }
                  </span>
              </div>
              <div class=" d-flex justify-content-between w-100">
                  <div>
                    <div class="mb-0" style="line-height: 21px;">

@if(exp && exp.title && exp.title.name){
   <span class="f-12 font-weight-500" style="color: #484b59; margin-bottom: 1px;"  [innerHTML]="highlightInfo(exp?.title?.name, 'past_jobtitle')">

                        </span>
}
                       @if(exp && exp.company && exp.company.name){

                        <span class="d-block f-12" style="margin-bottom: 4px;">

                            <span style="display: inline-block;" class="text-capitalize"  (mouseenter)="getCompanyInfo('past',exp, $event)" [class.companyHover]="exp?.company?.website"
[class.dstooltip]="exp?.company?.website"
[class.pointer]="exp?.company?.website">
                                <span  [innerHTML]="highlightInfo(exp?.company?.name, 'pastcompany')"></span>

                                <span class="dstooltip-content">
                                    <app-hire-company-hover-modal [companyInformation]="currentCompanyInformation"></app-hire-company-hover-modal>
                                </span>
                            </span>

                        </span>
                      }
                        <div class="d-flex align-items-center mb-1 text-9696">
                            <span class="text-9696 f-12 mb-0 text-truncate" style="margin-bottom: 4px; max-width: 50%;" [innerHTML]="highlightInfo(exp?.location_names.toString(), 'location')" matTooltip="{{exp?.location_names.toString()}}" [matTooltipClass]="{ 'red-tooltip': true }">
                            </span>
                            @if(exp?.location_names.toString() && exp?.start_date ){
                            <i class="fas fa-circle mx-1" style="font-size: 5px; color: #d9d9d9;" ></i>
                          }
                          @if(exp?.start_date) {
                            <span class="text-9696 f-12 mb-0" style="margin-bottom: 4px;" >
                                 {{formatDate(exp.start_date)}}  - {{exp.end_date != null ? formatDate(exp.end_date) : 'Current'}} {{exp.totaltenure ? '(' + exp.totaltenure + ')' : '' }}
                            </span>
                          }
                        </div>

                    </div>
                  </div>

              </div>
            </div>
            @if(exp?.expsummary || exp?.formattedExpSummary) {
              <div class="f-12 mb-0 exp-list" style="margin-bottom: 4px;"
                  [innerHTML]="highlightInfo(exp?.expsummary, 'exp_summary', {action: 'exp_summary', dataObj: exp?.formattedExpSummary})">
              </div>
              <div>
                @if(exp?.formattedExpSummary?.canOverflow && exp?.formattedExpSummary?.isTruncated) {
                  <span class="f-12 pointer text-webbtree-green"

                  (click)="formatDescription('view-more', exp)">
                  view more
                </span>
              }
              @if(exp?.formattedExpSummary?.canOverflow && !exp?.formattedExpSummary?.isTruncated) {
                <span class="f-12 pointer text-webbtree-green"
                (click)="formatDescription('view-less', exp)">
                view less
              </span>
            }
              </div>
            }
        </div>
@if(i != experience?.length - 1){
        <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin-bottom: 10px; margin-top: 10px;">

}


    </div>
}
